module.exports = __webpack_public_path__ + "img/bandera-usa.a08546c9.svg";